import React from 'react';
import PropTypes from 'prop-types';
import BaseButton from './BaseButton';
import LinkButton from './LinkButton';
import InputButton from './InputButton';
import ModalButton from './ModalButton';
import IconButton from './IconButton';

const Button = React.forwardRef(
  (
    { tag = 'button', variant = 'fill', appearance = 'primary', ...props },
    ref,
  ) => {
    const components = {
      button: BaseButton,
      a: LinkButton,
      input: InputButton,
      modal: ModalButton,
      icon: IconButton,
    };
    const Component = components[tag];

    return (
      <Component
        ref={ref}
        tag={tag}
        variant={variant}
        appearance={appearance}
        {...props}
      />
    );
  },
);

Button.propTypes = {
  tag: PropTypes.oneOf(['button', 'a', 'input', 'modal', 'icon']),
  variant: PropTypes.oneOf(['fill', 'outline', 'text', 'icon']),
  appearance: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
};

export default Button;
